export default __webpack_public_path__ + "static/media/bgvideo.f4178fa6.mp4";